import React from 'react';
import type { ReactElement } from 'react';
import {
  Card,
  CardContent,
  Button,
  Tooltip,
  CircularProgress,
} from '@mui/material';
import { withErrorBoundary } from 'Components/ErrorBoundary';
import classes from './SmallCard.module.scss';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

interface ISmallCardProps {
  title: string;
  tooltip?: string;
  data: number | string | ReactElement;
  percent?: boolean;
  color?: string;
  hideDetailsNavigation?: boolean;
  showDetails?: () => void;
  loading?: boolean;
}

const SmallCard = (props: ISmallCardProps) => {
  return (
    <Card className={classes.root}>
      <CardContent className={classes.content}>
        {props.loading ? (
          <div className={classes.loading}>
            <CircularProgress color="secondary" />
          </div>
        ) : (
          <React.Fragment>
            <div className={classes.title}>
              <p className={classes.titleText}>{props.title || 'No title'}</p>

              {props.tooltip && (
                <Tooltip
                  className={classes.tooltip}
                  title={props.tooltip}
                  arrow
                >
                  <HelpOutlineIcon fontSize="small" />
                </Tooltip>
              )}
            </div>
            <h1 style={{ color: props.color || '#3E7158' }}>
              {props.data}
              {props.percent && '%'}
            </h1>
            {props.showDetails && (
              <Button
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  props.showDetails?.();
                }}
                className={classes.btn}
                variant="text"
                type="button"
              >
                BEKIJKEN <ArrowForwardIcon />
              </Button>
            )}
          </React.Fragment>
        )}
      </CardContent>
    </Card>
  );
};

export default withErrorBoundary(SmallCard, {
  level: 'component',
  onError: (error, errorInfo) => {
    console.error('SmallCard error:', error, errorInfo);
  },
});
